module.exports = __webpack_public_path__ + "static/floral-c4b1564fc8d8820f725fcd7cd918a88e.png";